import connect from "@classdojo/web/utils/hoc/connect";
import TodayResult from "./TodayResult";
import { displayClose } from "src/pods/realtime";
import { appMetadataToday } from "src/pods/today";
import PresentationPage from "src/shared/components/PresentationPage";

type TodayResultContainerState = {
  notes: { text: string; title: string };
};
type TodayResultContainerProps = {
  text: string;
  title: string;
  fullscreen: boolean;
  displayClose: VoidFunction;
};

const mapStateToProps = (state: TodayResultContainerState) => {
  return { ...state.notes, fullscreen: true };
};
const mapDispatchToProps = { displayClose };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<TodayResultContainerProps>) => (
  <PresentationPage
    {...appMetadataToday()}
    onRequestHide={props.displayClose}
    closeButtonStyle={{ color: "dt_content_primary" }}
  >
    <TodayResult text={props.text} title={props.title} />
  </PresentationPage>
));
